import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { Labeled, ReferenceField, SimpleShowLayout, TextField, SelectField, useGetList } from "react-admin";
import { AddressTypeChoices } from "utils/choices";
import { accountRequests } from "api/accountApi";
import EditAddressInfoModal from "../Modals/EditAddressInfoModal";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

import { administrationRequests } from "api/administrationApi";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AddressData = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { data } = useGetList(
    accountRequests.getUserAddresses(record?.userId),
    {
      pagination: { page: 1, perPage: 999 },
    },
    { enabled: !!record?.userId },
  );

  return (
    <SimpleShowLayout>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Accordion sx={{ width: "100%" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
            <Typography
              color={"#4E2683"}
              sx={{ fontWeight: "bold" }}
            >
              Адреси
            </Typography>
          </AccordionSummary>{" "}
          <AccordionDetails sx={{ width: "100%" }}>
            <Grid
              item
              xs={12}
              p={2}
            >
              <SecuredComponent permission={permissions.canUpdateUsers}>
                <EditAddressInfoModal
                  record={record}
                  data={data}
                />
              </SecuredComponent>
            </Grid>
            {data?.map((item, idx) => (
              <Grid
                key={idx}
                spacing={2}
                gap={6}
                container
                sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
              >
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Тип адрес">
                    <SelectField
                      record={item}
                      source="type"
                      choices={AddressTypeChoices}
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Държава">
                    <ReferenceField
                      record={item}
                      source="countryId"
                      reference={administrationRequests.getCountriesSelect()}
                    >
                      <TextField source="nameBg" />
                    </ReferenceField>
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Град">
                    <ReferenceField
                      record={item}
                      source="settlementId"
                      reference={administrationRequests.getSettlementsSelect()}
                    >
                      <TextField
                        source="nameBg"
                        emptyText="-"
                      />
                    </ReferenceField>
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Адрес">
                    <TextField
                      record={item}
                      source="address"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Пощенски код">
                    <TextField
                      record={item}
                      source={"postalCode"}
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
              </Grid>
            ))}
          </AccordionDetails>
        </Accordion>
      </Grid>
    </SimpleShowLayout>
  );
};
export default AddressData;
